export class ZipModel {
    zip_code: string
    city: string
    county: string
    state: string
    rab_year: number

    constructor(
        zip_code: string,
        city: string,
        county: string,
        state: string,
        rab_year: number
    ) {
        this.zip_code = zip_code
        this.city = city
        this.county = county
        this.state = state
        this.rab_year = rab_year
    }
}